import { handleTaxRangeSlider } from './budget';


const bindBudgetActionsA = () => {
  const taxBoxes = document.querySelectorAll('.tax-small-box');
  handleTaxRangeSlider(taxBoxes);

  const swapFooterContent = () => {
    if ($(window).width() > 1200) {
      $('.footer--text').insertBefore($('.widget_footer'));
    } else {
      $('.widget_footer').insertBefore($('.footer--text'));
    }
  };
  swapFooterContent();
  $(window).on('resize', function () {
    swapFooterContent();
  });
};

window.addEventListener('load', () => {
  (function () {
    bindBudgetActionsA();
  })();
}, false);
